import './Start.scss'
import React, { useEffect } from 'react'
import { Slide } from '@material-ui/core'
import Head from '../Head/Head'
import { Translated } from '../../utils/translated'

const Start = (props) => {

    const buttonRef = React.useRef();

    useEffect(() => {
        if (!props.isShow)
            return

        setTimeout(() => {
            buttonRef.current && buttonRef.current.focus();
        }, 800);

    }, [props.isShow]);

    return (
        <Slide direction={props.direction} in={props.isShow} timeout={{ enter: 800, exit: 500 }} /* style={{ transitionDelay: '100ms' }} */ mountOnEnter unmountOnExit>
            <div className='start'>
                <Head isShow={true} width='303' height='360' />

                <button
                    ref={buttonRef}
                    className='btn-gradient'
                    onClick={() => props.onStart(false)}>
                    <Translated id='app.start.create' />
                </button>
                <button
                    className='btn-bold'
                    onClick={() => props.onStart(true)}>
                    <Translated id='app.start.have' />
                </button>
            </div>
        </Slide >
    )
}

export default Start
